import { isDefined } from '#misc/is-defined.guard';
import { isEmpty } from '#misc/is-empty';

/**
 * Formats a string by replacing placeholders with provided arguments.
 * Placeholders are in the format `{0}`, `{1}`, etc.
 *
 * @param {string} format - The format string containing placeholders.
 * @param {...string} args - The arguments to replace the placeholders with.
 * @returns {string} The formatted string with placeholders replaced by arguments.
 */
export const formatString = (format: string, ...args: string[]): string => {
  if (isEmpty(format)) {
    return '';
  }

  if (isEmpty(args)) {
    return format;
  }

  return format.replace(/{(\d+)}/g, (match, index: number) => {
    return isDefined(args[index]) ? args[index] : match;
  });
};
